module.exports = {"$schema":"https://vega.github.io/schema/vega-lite/v2.json","description":"A bar chart showing the US population distribution of age groups in 2000.","data":{"values":[]},"transform":[{"filter":"datum.year == 2000"}],"mark":"bar","encoding":{"y":{"field":"age","type":"ordinal","scale":{"rangeStep":17}},"x":{"aggregate":"sum","field":"people","type":"quantitative","axis":{"title":"population"}}}}


//////////////////
// WEBPACK FOOTER
// ./spec/vega-lite/bar_aggregate_empty.json
// module id = 1653
// module chunks = 1